import React from "react";

import { RemoveActionProvider } from "@main/producers/actions/remove/RemoveActionContext";
import { CreateActionProvider } from "@main/producers/actions/create/CreateActionContext";
import { ListActionProvider } from "@main/producers/actions/list/ListActionContext";
import ProducersPage from "@main/producers/pages/ProducersPage";
import {ResetPasswordActionProvider} from "@main/producers/actions/reset-password-mail/ResetPasswordActionContext";
import {ActiveOrDisableActionProvider} from "@main/producers/actions/active-or-disable-account/ActiveOrDisableActionContext";
import { ChangePasswordActionProvider } from "@main/producers/actions/change-password/ChangePasswordActionContext";


export default function ProducersRouterWrapper(props: { filters?: any, formDefaultValues?: any, formFilterValues?: any }) {
    const { filters, formDefaultValues, formFilterValues } = props;
    return (
      <ListActionProvider>
          <ActiveOrDisableActionProvider>
              <ResetPasswordActionProvider>
                    <ChangePasswordActionProvider>
                        <RemoveActionProvider>
                            <CreateActionProvider>
                                <ProducersPage filters={filters} formDefaultValues={formDefaultValues} formFilterValues={formFilterValues} />
                            </CreateActionProvider>
                        </RemoveActionProvider>
                    </ChangePasswordActionProvider>
              </ResetPasswordActionProvider>
          </ActiveOrDisableActionProvider>
      </ListActionProvider>
    );
};
